export default "__VITE_ASSET__DUpzjHnP__"